module.exports = __webpack_public_path__ + "media/images/whats-6ae3622bf2631a89cc30b89c64948ae0.png";